import TeamsPage from '../TeamsPage';

const PastTeamList = () => {
  return <TeamsPage />;
};

export default PastTeamList;
